<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0">
      <div class="col d-flex align-items-center justify-content-start g-0 m-0 ps-5 pt-2 pb-2">
        <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
        <app-status [statuses]="tokenStatuses" class="pe-2" (close)="onStatusOption($event)"></app-status>
        <div class="datepicker-container-wrapper position-relative">
          <div class="button-wrapper pe-2">
            <div class="button">
              <img alt="Date" src="assets/core/table-button/date.svg" />
              <div class="button-text" (click)="toggleModal()"
                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                  {{ selectedDate }}
                </ng-container>
                <ng-template #noDateSelected>
                  <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                </ng-template>
              </div>
              <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit" src="assets/device/x.svg"
                (click)="clearDates()" />
            </div>
          </div>
          @if (isDatepickerOpen) {
          <div class="overlay" (click)="toggleModal()"></div>
          <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
            [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate"></app-datepicker>
          }
        </div>
        <app-search placeholder="{{ 'SCHEDULED_DATA_SEARCHBY' | translate }}"
          (searchChange)="searchChange($event)"></app-search>
      </div>
      <div class="row g-0 m-0 pt-3 table-scroll">
        <table>
          <thead>
            <tr>
              <th></th>
              <th *ngFor="let column of columns">
                <div class="column-content">
                  <img alt="Column" src="assets/device/column-menu.svg" />
                  <span>{{ column.header | translate }}</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data; let i=index">
              <td appIsNew [executedTime]="row.startTime!" [seconds]="dayInMs"></td>
              <td *ngFor="let column of columns">
                <span *ngIf="column.header === 'DEVICESETUP_METERNO'"
                  (click)="clipboardService.copyToClipboard(row.meterNo!, $event, i)" class="copyable">
                  {{ row.meterNo }}
                  <span class="copy-tooltip" *ngIf="clipboardService.copiedText === i.toString()">{{"COPIED" |
                    translate}}</span>
                </span>
                <span *ngIf="column.header === 'DATE'">{{
                  ensureDate(row[column.key])
                  | date
                  : "EEE MMM
                  dd yyyy"
                  }}</span>
                <span *ngIf="column.header === 'REPORT_TOKEN_NUMBER'">
                  {{ row.token }}
                </span>
                <span *ngIf="column.header === 'COMMAND_SOURCE'" class="source-cell-container">
                  <div class="source-text-wrapper">
                    <span class="source-text">{{ row.source }}</span>
                  </div>

                  <div *ngIf="($any(row).failCount || 0) > 0" class="source-icon-wrapper">
                    <svg-icon class="retry-status-icon"
                      [src]="isMaxCommandReached(row) ? 'assets/settings/red-exclamation.svg' : 'assets/settings/yellow-exclamation.svg'"
                      [title]="getCommandTooltipText(row)">
                    </svg-icon>
                  </div>
                </span>
                <span *ngIf="column.header === 'TIME'">{{
                  ensureDate(row[column.key]) | date: "shortTime"
                  }}</span>
               <div *ngIf="column.key === 'tokenStatus'" class="status-container">
                  <span (click)="printResponseOfCommand($event,row)" class="text-wrapper" [ngClass]="{
                      'status-pending': row[column.key] === 'Pending',
                      'status-completed': row[column.key] === 'Success',
                      'status-failed': row[column.key] === 'Failed',
                    }">
                    {{ row[column.key] }}
                  </span>
                </div>
                <div *ngIf="column.key === 'commandStatus'" class="status-container">
                  <span class="text-wrapper" [ngClass]="{
                      'status-pending': row[column.key] === 'Pending',
                      'status-completed': row[column.key] === 'Success',
                      'status-failed': row[column.key] === 'Failed',
                      'status-fatal-error': row[column.key] === 'ErrorOccured',
                    }">
                    {{ row[column.key] === 'ErrorOccured' ? ('FATAL_ERROR' | translate) : row[column.key] }}
                  </span>
                  @if (row[column.key] === 'Failed' &&
                    authService.isAuthorized([PermissionsEnum.Remotecommands_clearcredit_execute])) {
                    <svg-icon class="retry-icon" src="assets/device/refresh.svg" (click)="retryCommand(row)"
                      title="Retry command">
                    </svg-icon>
                  }
                </div>
                <span *ngIf="
                    column.key !== 'tokenStatus' &&
                    column.key !== 'commandStatus' &&
                    column.header !== 'Date' &&
                    column.header !== 'Time' &&
                    column.key !== 'startTime' &&
                    column.key !== 'meterNo' &&
                    column.header !== 'REPORT_TOKEN_NUMBER' &&
                    column.header !== 'COMMAND_SOURCE'
                  ">
                  {{ row[column.key] }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <app-token-retry-dialog *ngIf="isModalOpen" [tokens]="sequentialTokens"
    (retry)="getRetryData(retryCommandId!); isModalOpen = false" (cancel)="isModalOpen = false"></app-token-retry-dialog>

  <div class="container-down">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
      [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
  </div>
</div>

<router-outlet></router-outlet>
